exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vux-tab .vux-tab-item {\n  white-space: nowrap;\n  padding: 0 10px;\n}\n.scrollable .vux-tab-ink-bar {\n  display: none;\n  opacity: 0;\n}\n.vux-swiper-item {\n  overflow: scroll;\n  padding-bottom: 100px;\n}\n@media screen and (min-width: 600px) {\n.type .vux-tab .vux-tab-item {\n    padding-right: 5%;\n}\n.type .vux-tab-container {\n    max-width: 1000px;\n    margin: auto;\n}\n.type .scrollable {\n    cursor: pointer;\n}\n.type .scrollable .vux-tab-item {\n    -ms-flex-preferred-size: 0px;\n        flex-basis: 0px;\n}\n}\n", ""]);

// exports
